module.exports = __webpack_public_path__ + "static/banner-16b2ad4c2ff093121b016472d86de547.jpg";